import {
  Box,
  Text,
  Heading,
  IconChevron,
  Stack,
  Button,
  Actions,
  IconPositive,
} from 'braid-design-system';
import React from 'react';
interface ThanksViewProps {
  setSubmitted: (submitted: boolean) => void;
}
const ThanksView = ({ setSubmitted }: ThanksViewProps) => (
  <Box paddingBottom="xxlarge">
    <Stack space="xlarge">
      <Stack space="gutter">
        <Heading level="2" icon={<IconPositive tone="positive" />}>
          Thanks for contacting us
        </Heading>
        <Text>
          Our customer service team will be in touch shortly to discuss the next
          steps.
        </Text>
      </Stack>
      <Actions>
        <Button onClick={() => setSubmitted(false)} variant="ghost">
          <IconChevron direction="left" /> {'Back to enquiry page'}
        </Button>
      </Actions>
    </Stack>
  </Box>
);

export default ThanksView;
